import axios from "./axios"
export const LOGIN_URL  = location.origin +  '/uc/login'